import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'methaTheme';
const DEFAULT_THEME = 'dark';

/**
 * useTheme — toggles dark / light, persists in localStorage.
 * Initial render uses DEFAULT_THEME so SSR/first paint is deterministic;
 * the persisted value is read in a useEffect after mount.
 */
export default function useTheme() {
  const [theme, setTheme] = useState(DEFAULT_THEME);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved === 'dark' || saved === 'light') setTheme(saved);
    } catch (e) {
      // localStorage may be disabled (private mode); silently fall back
    }
  }, []);

  const toggle = useCallback(() => {
    setTheme(prev => {
      const next = prev === 'dark' ? 'light' : 'dark';
      try { window.localStorage.setItem(STORAGE_KEY, next); } catch (e) {}
      return next;
    });
  }, []);

  return [theme, toggle];
}
